import { createMRTColumnHelper, MRT_ColumnDef } from 'material-react-table'
import { useMemo } from 'react'

import { TextCell } from '@/components'
import { createHeaderWithTooltip } from '@/components/MrtTable/helpers'
import { useAppContext } from '@/hooks'
import { useDetailTabContext } from '@/pages/User/pages/Home/components/DetailTab'
import { RelationDto } from '@/rtkApi/mddApiSliceGenerated'

import { DependenciesActions, DependenciesLinkCell } from '../components'

export const useDepColumns = () => {
	const { t } = useAppContext()
	const {
		state: { node, editMode },
	} = useDetailTabContext()

	const columnHelper = createMRTColumnHelper<RelationDto>()

	const columns = useMemo(
		() => [
			columnHelper.accessor('name', {
				...createHeaderWithTooltip(t('NAME')),
				Cell: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
						isDisabled={!editMode}
					/>
				),
			}),
			columnHelper.accessor('code', {
				...createHeaderWithTooltip(t('CODE')),
				Cell: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
						isDisabled={!editMode}
					/>
				),
			}),
			columnHelper.accessor('description', {
				...createHeaderWithTooltip(t('DESCRIPTION')),
				Cell: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
						isDisabled={!editMode}
					/>
				),
			}),
			columnHelper.accessor('relationType', {
				...createHeaderWithTooltip(t('TYPE')),
				Cell: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
						isDisabled={!editMode}
					/>
				),
			}),
			columnHelper.accessor('status', {
				...createHeaderWithTooltip(t('STATUS')),
				Cell: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
						isDisabled={!editMode}
					/>
				),
			}),
			columnHelper.accessor('rightSideStructure', {
				...createHeaderWithTooltip(t('ELEMENT')),
				size: 100,
				Cell: ({ row }) => <DependenciesLinkCell row={row} node={node} />,
			}),
			columnHelper.accessor('rightSideColumn', {
				header: '',
				size: 50,
				enableColumnActions: false,
				enableSorting: false,
				Cell: ({ row }) => <DependenciesActions row={row} />,
			}),
		],
		[columnHelper, editMode, node, t],
	)

	return columns as MRT_ColumnDef<RelationDto>[]
}
